module.exports = __webpack_public_path__ + "static/media/yellowCurveConcave.2d85008a.svg";